import { hasPermission, type PermissionKey, type PermissionScope } from '@stoplord/shared';
import { useAuth } from '@/store/auth';

export function useCan() {
  const perms = useAuth((s) => s.user?.permissions);
  return (key: PermissionKey, minScope: PermissionScope = 'own') => !!perms && hasPermission(perms, key, minScope);
}

export function useTerms() {
  const t = useAuth((s) => s.tenant?.terminology);
  return (
    t ?? {
      client: { singular: 'Client', plural: 'Clients' },
      lead: { singular: 'Lead', plural: 'Leads' },
      employee: { singular: 'Employee', plural: 'Employees' },
      task: { singular: 'Task', plural: 'Tasks' },
    }
  );
}
